module.exports = __webpack_public_path__ + "media/common/images/badges/gray/jizda_pod_plynem-6bd41749b383fb1256a78f7c305adb76.svg";